<template>
  <svg 
    width="20px" 
    height="20px" 
    viewBox="0 0 20 20" 
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :class="{ 'inactive': !active }"
    @click="toggle"
  >
    <defs />

    <g
      id="Modal"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="01_mobile-views"
        transform="translate(-1100.000000, -912.000000)"
      >
        <g
          id="w-basic"
          transform="translate(880.000000, 744.000000)"
        >
          <g
            id="filter"
            transform="translate(20.000000, 158.000000)"
          >
            <g
              id="search"
              transform="translate(190.000000, 0.000000)"
            >
              <g
                id="Icon-/-Location-Filter-Disabled"
                transform="translate(8.000000, 8.000000)"
              >
                <g id="ic_language_black_24px">
                  <polygon
                    id="Shape"
                    points="0 0 24 0 24 24 0 24"
                  />
                  <path
                    id="Shape"
                    d="M11.99,2 C6.47,2 2,6.48 2,12 C2,17.52 6.47,22 11.99,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 11.99,2 Z M18.92,8 L15.97,8 C15.65,6.75 15.19,5.55 14.59,4.44 C16.43,5.07 17.96,6.35 18.92,8 Z M12,4.04 C12.83,5.24 13.48,6.57 13.91,8 L10.09,8 C10.52,6.57 11.17,5.24 12,4.04 Z M4.26,14 C4.1,13.36 4,12.69 4,12 C4,11.31 4.1,10.64 4.26,10 L7.64,10 C7.56,10.66 7.5,11.32 7.5,12 C7.5,12.68 7.56,13.34 7.64,14 L4.26,14 Z M5.08,16 L8.03,16 C8.35,17.25 8.81,18.45 9.41,19.56 C7.57,18.93 6.04,17.66 5.08,16 L5.08,16 Z M8.03,8 L5.08,8 C6.04,6.34 7.57,5.07 9.41,4.44 C8.81,5.55 8.35,6.75 8.03,8 L8.03,8 Z M12,19.96 C11.17,18.76 10.52,17.43 10.09,16 L13.91,16 C13.48,17.43 12.83,18.76 12,19.96 Z M14.34,14 L9.66,14 C9.57,13.34 9.5,12.68 9.5,12 C9.5,11.32 9.57,10.65 9.66,10 L14.34,10 C14.43,10.65 14.5,11.32 14.5,12 C14.5,12.68 14.43,13.34 14.34,14 Z M14.59,19.56 C15.19,18.45 15.65,17.25 15.97,16 L18.92,16 C17.96,17.65 16.43,18.93 14.59,19.56 L14.59,19.56 Z M16.36,14 C16.44,13.34 16.5,12.68 16.5,12 C16.5,11.32 16.44,10.66 16.36,10 L19.74,10 C19.9,10.64 20,11.31 20,12 C20,12.69 19.9,13.36 19.74,14 L16.36,14 Z"
                    fill="#13BF4C"
                    fill-rule="nonzero"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  data () {
    return {
      active: true
    }
  },

  methods: {
    toggle () {
      this.active = !this.active;
      // this.$emit('toggle-localization', this.active);
    }
  }
}
</script>

<style lang="scss" scoped>
 svg:hover path {
   fill: #36d951;
 }

 svg.inactive path {
  fill: #b4b5b8;
}
</style>

